import React, { useState } from "react";
import { Form, Input, Button, Select, Upload, Checkbox } from "antd";
import { UploadOutlined, PlusOutlined } from "@ant-design/icons";
import API from "../../../utils/api"; // Uvozimo API instancu
import { toast } from "react-toastify";

const { Option } = Select;

const AddProduct = () => {
  const [product, setProduct] = useState({
    name: "",
    sku: "",
    price: "",
    discountPrice: "",
    discount: "",
    category: "",
    stock: "",
    isFeatured: false,
    isOnSale: false,
    shortDescription: "",
    longDescription: "",
    images: [],
    attributes: {},
    variants: [],
    seoTitle: "",
    seoDescription: "",
    seoKeywords: "",
  });

  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    setProduct({ ...product, [e.target.name]: e.target.value });
  };

  const handleCheckboxChange = (e) => {
    setProduct({ ...product, [e.target.name]: e.target.checked });
  };

  const handleCategoryChange = (value) => {
    setProduct({ ...product, category: value });
  };

  const handleAddAttribute = () => {
    const newAttribute = `Atribut ${
      Object.keys(product.attributes).length + 1
    }`;
    setProduct({
      ...product,
      attributes: { ...product.attributes, [newAttribute]: "" },
    });
  };

  const handleAddVariant = (value) => {
    setProduct({ ...product, variants: [...product.variants, value] });
  };

  const handleUpload = ({ fileList }) => {
    setProduct({ ...product, images: fileList });
  };

  // ✅ Slanje proizvoda na backend
  const handleSubmit = async () => {
    if (!product.name || !product.price || !product.category) {
      toast.error("Molimo popunite sva obavezna polja!");
      return;
    }

    try {
      setLoading(true);

      // 🟢 1. API poziv za kreiranje proizvoda
      const { data } = await API.post("/products", product);
      toast.success("Proizvod uspešno dodat!");

      // 🟢 2. Ako ima slike, odmah ih uploadujemo
      if (product.images.length > 0) {
        await handleUploadImages(data.id);
      }

      // Resetujemo formu
      setProduct({
        name: "",
        sku: "",
        price: "",
        discountPrice: "",
        discount: "",
        category: "",
        stock: "",
        isFeatured: false,
        isOnSale: false,
        shortDescription: "",
        longDescription: "",
        images: [],
        attributes: {},
        variants: [],
        seoTitle: "",
        seoDescription: "",
        seoKeywords: "",
      });
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Greška pri dodavanju proizvoda!"
      );
    } finally {
      setLoading(false);
    }
  };

  // ✅ Upload slika na backend
  const handleUploadImages = async (productId) => {
    const formData = new FormData();
    product.images.forEach((file) => {
      formData.append("image", file.originFileObj);
    });

    try {
      await API.post(`/products/${productId}/upload-image`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      toast.success("Slike uspešno dodate!");
    } catch (error) {
      toast.error("Greška pri uploadu slika!");
    }
  };

  return (
    <div style={{ maxWidth: "700px", margin: "0 auto", padding: "20px" }}>
      <h2>Dodaj novi proizvod</h2>
      <Form layout="vertical" onFinish={handleSubmit}>
        {/* Naziv proizvoda */}
        <Form.Item label="Naziv proizvoda">
          <Input
            name="name"
            value={product.name}
            onChange={handleInputChange}
          />
        </Form.Item>

        {/* SKU kod */}
        <Form.Item label="SKU">
          <Input name="sku" value={product.sku} onChange={handleInputChange} />
        </Form.Item>

        {/* Cena i popust */}
        <Form.Item label="Cena">
          <Input
            name="price"
            value={product.price}
            onChange={handleInputChange}
          />
        </Form.Item>
        <Form.Item label="Cena na sniženju">
          <Input
            name="discountPrice"
            value={product.discountPrice}
            onChange={handleInputChange}
          />
        </Form.Item>
        <Form.Item label="Popust (%)">
          <Input
            name="discount"
            value={product.discount}
            onChange={handleInputChange}
          />
        </Form.Item>

        {/* Kategorija */}
        <Form.Item label="Kategorija">
          <Select value={product.category} onChange={handleCategoryChange}>
            <Option value="Gaming oprema">Gaming oprema</Option>
            <Option value="Kuhinjski uređaji">Kuhinjski uređaji</Option>
            <Option value="Računari">Računari</Option>
          </Select>
        </Form.Item>

        {/* Stanje na lageru */}
        <Form.Item label="Stanje na lageru">
          <Input
            name="stock"
            value={product.stock}
            onChange={handleInputChange}
          />
        </Form.Item>

        {/* Istaknuti proizvod i na akciji */}
        <Form.Item>
          <Checkbox
            name="isFeatured"
            checked={product.isFeatured}
            onChange={handleCheckboxChange}
          >
            Istaknuti proizvod
          </Checkbox>
          <Checkbox
            name="isOnSale"
            checked={product.isOnSale}
            onChange={handleCheckboxChange}
          >
            Na akciji
          </Checkbox>
        </Form.Item>

        {/* Opisi */}
        <Form.Item label="Kratak opis">
          <Input
            name="shortDescription"
            value={product.shortDescription}
            onChange={handleInputChange}
          />
        </Form.Item>
        <Form.Item label="Detaljan opis">
          <Input.TextArea
            name="longDescription"
            value={product.longDescription}
            onChange={handleInputChange}
            rows={4}
          />
        </Form.Item>

        {/* Slike */}
        <Form.Item label="Slike proizvoda">
          <Upload listType="picture" onChange={handleUpload} multiple>
            <Button icon={<UploadOutlined />}>Dodaj slike</Button>
          </Upload>
        </Form.Item>

        {/* SEO Optimizacija */}
        <Form.Item label="SEO Naslov">
          <Input
            name="seoTitle"
            value={product.seoTitle}
            onChange={handleInputChange}
          />
        </Form.Item>
        <Form.Item label="SEO Opis">
          <Input.TextArea
            name="seoDescription"
            value={product.seoDescription}
            onChange={handleInputChange}
            rows={2}
          />
        </Form.Item>
        <Form.Item label="SEO Ključne reči">
          <Input
            name="seoKeywords"
            value={product.seoKeywords}
            onChange={handleInputChange}
          />
        </Form.Item>

        {/* Dugme za dodavanje proizvoda */}
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading}>
            {loading ? "Dodavanje..." : "Dodaj proizvod"}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default AddProduct;
